import z from 'zod';

export const EntitySchema = z.object({
    id: z.guid(),
});

export type Entity = z.infer<typeof EntitySchema>;
